import useCreditSellerCardController from './useCreditSellerCardController'
import { formatPhoneNumber } from '@/app/utils/formatPhoneNumber'
import {
  Avatar,
  AvatarFallback,
  AvatarImage,
} from '@/view/components/ui/avatar'
import { stringToColour } from '@/app/utils/changeBackgroundColorOfInitials'
import { getNameInitial } from '@/app/utils/getNameInitial'
import { Button } from '@/view/components/ui/button'

const CreditSellerCard = () => {
  const { seller, handleWhatsAppClick } = useCreditSellerCardController()

  return (
    <div className="mb-6 flex w-full max-w-[571px] items-center gap-4 rounded-2xl border border-gray02 bg-white01">
      <Button
        onClick={handleWhatsAppClick}
        variant="ghost"
        className="flex w-full items-center justify-between px-5 py-16"
      >
        <div className="flex-1 space-y-2 text-left">
          <p className="text-sm font-medium text-black04 sm:text-base">
            Atendido por
          </p>
          <p className="text-base font-bold text-black01 sm:text-xl">
            {seller?.name}
          </p>
          <p className="text-black06 text-sm font-medium sm:text-base">
            {formatPhoneNumber(seller?.phone || '')}
          </p>
        </div>
        <Avatar className="h-12 w-12 sm:h-16 sm:w-16">
          <AvatarImage
            src={
              seller?.profileImageUrl
                ? `${import.meta.env.VITE_CDN_URL}${seller?.profileImageUrl}`
                : undefined
            }
          />
          <AvatarFallback
            className="text-lg"
            style={{
              backgroundColor: stringToColour(seller?.name || ''),
            }}
          >
            {getNameInitial(seller?.name || '')}
          </AvatarFallback>
        </Avatar>
      </Button>
    </div>
  )
}

export default CreditSellerCard
